import { Flex, Tooltip, Text } from "@chakra-ui/react";
import { LogoutIcon } from "@root/assets/icons";
import { CustomText } from "@root/components/common/components";
import { LanguageNav } from "@root/components/common/sidebar/languageNav";
import { CenterFlex, ColumnFlex } from "@root/components/dashboard/chat/style";
import { isRouteExist } from "@root/utils/helpers";
import { useTranslation } from "react-i18next";
import { StyledItemsContainer, StyledSidebar } from "@root/components/adminDashboard/style";
import useSuperAdminSidebar from "@root/hooks/useSuperAdminSidebar";
import { useGlobalContext } from "@root/context/global-context";
import { NavControl } from "@root/components/dashboard/sidebar/navControl";
import { LogoutModal } from "@root/components/logout/logout";

function SuperAdminSidebar() {
    const { t } = useTranslation("common");

    const {
        sidebarItems,
        pathname,
        superAdminLogoutHandler,
        menuItemsList,
        profileData,
        setIsMenuOpen,
        isMenuOpen,
        logoutPopup,
        setLogoutPopup,
    } = useSuperAdminSidebar();
    const { isSidebarOpen, setIsSidebarOpen } = useGlobalContext();

    return (
        <StyledSidebar width={"340px"}>
            <StyledItemsContainer>
                <Flex alignItems="center" height="56px" mb="8px" px="16px">
                    <Text
                        fontSize="28px"
                        fontWeight="700"
                        color="#15161A"
                        letterSpacing="0.5px"
                    >
                        DOAZ
                    </Text>
                </Flex>
                {sidebarItems?.map((item: any, key: number) => {
                    const isHr = item?.type === "hr";
                    if (isHr) {
                        return null;
                    }
                    return (
                        <Tooltip label={""} placement="right" key={key}>
                            <Flex flexDir={"column"} userSelect={"none"}>
                                <Flex
                                    width={"100%"}
                                    height={"55px"}
                                    borderRadius={"8px"}
                                    bgColor={
                                        isRouteExist(pathname, item?.routes, item?.DRoutes)
                                            ? "theme.alert.200"
                                            : "transparent"
                                    }
                                    onClick={() => item?.onClick()}
                                    cursor={"pointer"}
                                    justifyContent={"space-between"}
                                    alignItems={"center"}
                                    px={"16px"}
                                >
                                    <CenterFlex gap={"14px"}>
                                        {isRouteExist(pathname, item?.routes, item?.DRoutes)
                                            ? item.activeIcon
                                            : item.icon}
                                        <CustomText
                                            fontSize={"16px"}
                                            fontWeight={500}
                                            textColor={
                                                isRouteExist(pathname, item?.routes, item?.DRoutes)
                                                    ? "#1782FF"
                                                    : "#15161A"
                                            }
                                            text={item?.title}
                                        />
                                    </CenterFlex>
                                </Flex>
                            </Flex>
                        </Tooltip>
                    );
                })}
            </StyledItemsContainer>
            <ColumnFlex width={"100%"} gap={"16px"} alignItems={"auto"}>
                <LanguageNav isOpen={true} />

                <Tooltip label={""} placement="right">
                    <Flex flexDir={"column"} gap={"16px"}>
                        <NavControl
                            pathname={pathname}
                            menuItemsList={menuItemsList}
                            isOpen={isSidebarOpen}
                            profileData={profileData}
                            isMenuOpen={isMenuOpen}
                            setIsMenuOpen={setIsMenuOpen}
                            setLogoutPopup={setLogoutPopup}
                        />
                    </Flex>
                </Tooltip>
                <LogoutModal
                    isOpen={logoutPopup}
                    onClose={() => setLogoutPopup(false)}
                    onConfirm={superAdminLogoutHandler}
                />
            </ColumnFlex>
        </StyledSidebar>
    );
}

export default SuperAdminSidebar;
